import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getDownloadReportButtonTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    common: {
      download_reports: {
        title: 'TITLE',
        format_label: 'FORMAT_LABEL',
        separator_label: 'SEPARATOR_LABEL',
        create_report_success: 'CREATE_REPORT_SUCCESS',
        ok: 'OK',
      },
    },
  }));
}

export function getAdminDownloadReportTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      export: {
        download_csv: {
          header: 'HEADER',
          remove_modal: {
            title: 'MODAL_TITLE',
            question: 'MODAL_QUESTION',
            answer_yes: 'MODAL_YES',
            answer_no: 'MODAL_NO',
          },
          aasm_state: {
            in_progress: 'STATE_IN_PROGRESS',
            ready: 'STATE_READY',
          },
          table_actions: {
            download_report_csv: 'DOWNLOAD_REPORT_CSV',
            download_report_xlsx: 'DOWNLOAD_REPORT_XLSX',
            remove_report: 'REMOVE_REPORT',
          },
        },
      },
    },
  }));
}

export function getAffiliateDownloadReportTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    affiliate: {
      export: {
        download_csv: {
          header: 'HEADER',
          remove_modal: {
            title: 'MODAL_TITLE',
            question: 'MODAL_QUESTION',
            answer_yes: 'MODAL_YES',
            answer_no: 'MODAL_NO',
          },
          aasm_state: {
            in_progress: 'STATE_IN_PROGRESS',
            ready: 'STATE_READY',
          },
          table_actions: {
            download_report_csv: 'DOWNLOAD_REPORT_CSV',
            download_report_xlsx: 'DOWNLOAD_REPORT_XLSX',
            remove_report: 'REMOVE_REPORT',
          },
        },
      },
    },
  }));
}
